/**
 * Config/init testimonial slider
 * 
 * @since 1.0.0
 * @package lockbusters
 */
(function($) {
	$(document).ready(function() {

		/**
         * Check if swiper gallery is in scope/loaded!
         */
        if ( ! ( 'swiper' in $.fn ) ) {
            return;
        }

		var testimonialSlider = new Swiper( '.testimonial-slider', {
			effect				: 'flip',
			loop				: true,
			pagination			: '.pagination',
			paginationClickable	: true,
			speed				: 2500,
		});


	}); // document.ready()
})(jQuery);